/**
 * Methods for enhancing the filter
 *
 * @class Filter
 * @author EN GARDE
 * @version 1.0
 */

import _ from 'lodash';

/**
 * @constructor
 */
export default function Filter($filter, options) {
	var that = this;

	that.$filter = $filter;
	that.count = 0;
	that.options = _.defaultsDeep(that.defaults, options);
}

Filter.prototype.defaults = {
	selectors: {
		counter: '.en-filter-counter',
		countFields: 'input[type="checkbox"]'
	}
};

Filter.prototype.initCounter = function () {
	var that = this;

	that.$filter.on('change', function () {
		that.updateCounter();
	});

	that.updateCounter();
};

Filter.prototype.updateCounter = function () {
	var that = this;
	var $fields = that.$filter.find(that.options.selectors.countFields);
	var $counters = that.$filter.find(that.options.selectors.counter);
	var oldCount = that.count;

	that.count = 0;

	$fields.each(function () {
		if ($(this).prop('checked')) {
			that.count++;
		}
	});

	if (oldCount !== that.count) {
		$counters.attr('data-en-filter-count', that.count);

		that.$filter.trigger('updateCounter', {
			count: that.count,
			$fields: $fields,
			$counters: $counters
		});
	}
};
